export const colors = {
  secondaryBlue50: '#E4F2FF',
  secondaryBlue700: '#4671EA',
  secondaryYellow50: '#FFF3E0',
  secondaryYellow700: '#F57C00',
  secondaryOrange50: '#FCE9E6',
  secondaryOrange800: '#D94900',
  primaryGreen50: '#E7F4E6',
  primaryGreen700: '#2E8722',
  neutralDarkGray900: '#1C1C1C',
  neutralDarkGray700: '#5B5B5B',
};

export const paddings = {
  padding2x: '8px',
  padding3x: '12px',
};

export default {
  ...paddings,
  ...colors,
};
